export const MAX_RECENTLY_VIEWED = 8;

/** Slim product snapshot for localStorage — enough for cards & quick add */
export const snapshotProduct = (product) => ({
  id: product.id,
  name: product.name,
  image: product.image,
  images: product.images,
  price: product.price,
  compare_at_price: product.compare_at_price ?? null,
  sizes: product.sizes,
  color: product.color,
  category: product.category,
  category_name: product.category_name,
  stock_count: product.stock_count,
  listing_status: product.listing_status,
  is_active: product.is_active,
  is_new: product.is_new,
});
